import React, { useContext } from 'react'
import classNames from 'classnames'
import Next from '../Controls/Directional/Next'
import Previous from '../Controls/Directional/Previous'
import { SliderNavigationProps } from '@toasttab/shared/src/components/molecules/SliderNavigation/SliderNavigation.d'
import { OTLContext } from '@toasttab/shared/src/context/OTLContext'

const SliderNavigation = ({
  classes = '',
  previousNextButtons = 'null'
}: SliderNavigationProps) => {
  const otlParams = useContext(OTLContext)
  const OTLArticleUX: boolean = Boolean(otlParams.isArticle)
  const navVariation =
    previousNextButtons === 'slide-nav-blue-75-inverse'
      ? 'secondary'
      : 'primary'

  const navigationCss = classNames({
    '!left-[-64px] !right-[-64px] absolute': !OTLArticleUX,
    'relative lg:left-[-64px] lg:right-0 mt-6 lg:mt-0': OTLArticleUX,
    'top-0 bottom-6 items-center justify-between': true
  })

  if (previousNextButtons === 'null') return null
  return (
    <div
      className={`swiper-navigation ${navigationCss} ${previousNextButtons} ${classes}`}
    >
      <button className='swiper-button-prev !lg:ml-[-24px] [&.swiper-button-disabled]:hidden'>
        <Previous variation={navVariation} />
      </button>
      <button className='swiper-button-next !lg:mr-[-24px] [&.swiper-button-disabled]:hidden'>
        <Next variation={navVariation} />
      </button>
    </div>
  )
}

export default SliderNavigation
